import { createFileRoute, useParams } from "@tanstack/react-router";

import { InvoiceReviewPanel } from "@/components/shared/invoice-review/invoice-review-panel";
import InvoiceReviewForm from "@/features/invoice-standard-review/accounting/InvoiceReview";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_focused/rechnung/$id/",
)({
  component: InvoiceReview,
});

function InvoiceReviewClient({ invoiceId }: { invoiceId: string }) {
  return <InvoiceReviewForm key={invoiceId} />;
}

function InvoiceReview() {
  const { id: invoiceId } = useParams({ from: Route.id });

  return (
    <InvoiceReviewPanel
      invoiceId={invoiceId}
      invoiceViewerPanel={{ defaultSize: 45, maxSize: 55 }}
      invoiceReviewPanel={{
        maxSize: 75,
        defaultSize: 55,
        component: InvoiceReviewClient,
      }}
    />
  );
}
